export const videoGallery = [
  {
    title: 'Nutricare Initiative',
    description: 'Community health and nutrition program making a positive impact on student wellness and healthy living.',
    date: 'March 2024',
    duration: '0:45',
    category: 'Community',
    thumbnail: 'https://img.youtube.com/vi/tbhQx-3heFM/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/tbhQx-3heFM'
  },
  {
    title: 'Guitar Awards Performance',
    description: 'Showcasing exceptional guitar skills and musical artistry at the guitar awards ceremony.',
    date: 'March 2024',
    duration: '0:52',
    category: 'Performance',
    thumbnail: 'https://img.youtube.com/vi/veKtrlbvTeA/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/watch?v=veKtrlbvTeA',
    isExternalLink: true
  },
  {
    title: 'Gables Voice Journalism',
    description: 'Behind the scenes of Gables Voice student journalism, showcasing news coverage and media production.',
    date: 'March 2024',
    duration: '0:35',
    category: 'Journalism',
    thumbnail: 'https://img.youtube.com/vi/AhosxV7LOxc/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/shorts/AhosxV7LOxc',
    isExternalLink: true
  }
];
